/**
 * Helps us determine subscription status for both strings and booleans
 * @param {(string|boolean)} isSubscribed - Takes isSubscribed from subscriptions array
 * @returns {{bool: boolean, str: string}} Status an object with bool and str properties. Use the boolean to determine if subscription is active, string for displaying status.
 */
export default function isSubscribedHelper(isSubscribed) {
    //default to unsubscribed
    let bool = false;
    let str = 'Not Subscribed'

    //boolean - subscribed
    if (typeof isSubscribed === "boolean" && isSubscribed){
      bool = isSubscribed;
      str = 'Subscribed'
    }
    //string
    if(typeof isSubscribed === "string"){
        console.log(isSubscribed)
      //Subscribed
      if(isSubscribed === 'active'){
        bool = true;
        str = 'Subscribed'
      }
      //expired
      if(isSubscribed === 'expired'){
        bool = false;
        str = 'Expired'
      }
      if(isSubscribed === 'canceled'){
        bool = false;
        str = 'Canceled'
      }
    }
    const status = {bool, str,}
    console.log('status', status)
    return status
 }